export const TOGGLE_LOADING = 'admin/snapshot/TOGGLE_LOADING'
export const TOGGLE_SUCCESS = 'admin/snapshot/TOGGLE_SUCCESS'
export const GET_SNAPSHOT = 'admin/snapshot/GET_SNAPSHOT'
export const SET_SNAPSHOT = 'admin/snapshot/SET_SNAPSHOT'
export const CREATE_SNAPSHOT = 'admin/snapshot/CREATE_SNAPSHOT'
export const DELETE_SNAPSHOT = 'admin/snapshot/DELETE_SNAPSHOT'
export const GET_STATIC_OPTIONS = 'admin/snapshot/GET_STATIC_OPTIONS'
export const SET_OPTIONS = 'admin/snapshot/SET_OPTIONS'
export const SET_PERMISSIONS = 'admin/snapshot/SET_PERMISSIONS'
